module.exports = __webpack_public_path__ + "img/success.d3a6ebb5.png";